<template>
  <el-dialog
    :title="$t('wiioRechargeTitle')"
    v-model="isOpen"
    width="500px"
    @close="handleCancel"
  >
    <div class="dialog-body">
      <p class="dialog-message">{{ $t('wiioRechargeDesc') }}</p>
    </div>

    <template #footer>
      <el-button @click="handleCancel">{{ $t('cancel') }}</el-button>
      <el-button type="primary" @click="handleConfirm">{{
        $t('wiilRechargeConfirm')
      }}</el-button>
    </template>
  </el-dialog>
</template>

<script setup lang="ts">
import platformManager from '@/service/PlatformManager'
import { ref, watch } from 'vue'

const emit = defineEmits(['update:visible', 'confirm', 'cancel'])
const props = defineProps({
  visible: {
    type: Boolean,
    default: false
  },
  data: {
    type: Object,
    default: () => ({})
  }
})
const $t: any = inject('$t')

const isOpen = ref(false)

watch(
  () => props.visible,
  (newVal) => {
    isOpen.value = newVal
  }
)

watch(isOpen, (newVal) => {
  emit('update:visible', newVal)
})

const handleCancel = () => {
  isOpen.value = false
  emit('cancel')
}

const handleConfirm = async () => {
  const loading = ElLoading.service({
    lock: true,
    background: 'rgba(0, 0, 0, 0.7)'
  })
  await platformManager.jumpToRechargePage(props.data.BackUrl).finally(() => {
    loading.close()
  })
  isOpen.value = false
  emit('confirm')
}
</script>

<style scoped lang="scss">
.dialog-body {
  text-align: center;
  padding: 20px 0;
}
.dialog-message {
  font-size: 16px;
  color: #333;
}
</style>
